import axiosClient from "./axiosClient";

const accoutingFinancial = {
  //
  getLitRevenuesItem: async (params) => {
    const url = "/store/tckt/doanh-thu-theo-item-customer";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  GetRevenuesCustomer: async (params) => {
    const url = `/store/tckt/doanh-thu-theo-kh`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  etRevenuesSurgery: async (params) => {
    const url = `/store/tckt/doanh-thu-theo-kh`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getDetailStore: async (params) => {
    const url = `/store/tckt/kho-chi-tiet`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getAllStore: async (params) => {
    const url = `/store/tckt/kho-tong-hop`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
 //Báo cáo marketing
 getListMarketing: async (params) => {
  const url = `/qlttbhyt-service/thanh-toan/lan-kham/bao-cao-marketing`;
  const response = await axiosClient.get(url, { params: params });
  return response;
},
//Xuất báo cáo marketing
getExportMarketing: async (param) => {
  const url = `/qlttbhyt-service/thanh-toan/lan-kham/export-bao-cao-marketing`;
  const response = await axiosClient.get(url, {
    params: param,
    responseType: "blob",
  });
  return response;
},
 //Báo cáo thẻ khám
 getListTheKham: async (params) => {
  const url = `/qlkhambenh/loai-the-kham/paging`;
  const response = await axiosClient.get(url, { params: params });
  return response;
},
//Xuất báo cáo thẻ khám
getExportTheKham: async (param) => {
  const url = `/qlkhambenh/loai-the-kham/export-bao-cao-the-kham`;
  const response = await axiosClient.get(url, {
    params: param,
    responseType: "blob",
  });
  return response;
},
  //Lấy danh sách theo phẫu thuật

  getListSurgery: async (params) => {
    const url = `/qlttbhyt-service/thanh-toan/lan-kham/bao-cao-doanh-thu-phau-thuat`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  //Kho nhập xuất
  getStore: async (params) => {
    const url = `/store/store/list-store`;
    const response = await axiosClient.get(url, { params: params });
    return response.data.data;
  },
  //Loại hình thanh toán
  getLHTT: async () => {
    const url = `/store/payments/list-payments`;
    const response = await axiosClient.get(url);
    return response.data.data;
  },
};

export default accoutingFinancial;
